import { AuthenticationService } from 'src/app/services/authentication.service';
import { Component, ElementRef, HostListener, Input, TemplateRef, ViewChild, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'src/app/services/api.service';
import { appConstants } from 'src/app/services/constants/app.constants';
import { forkJoin } from 'rxjs';
@Component({
  selector: 'app-poshvine-search-widget',
  templateUrl: './search-widget.component.html',
  styleUrls: ['./search-widget.component.scss'],
})
export class SearchWidgetComponent {
  public assetsPath = './../../../assets';
  protected isPanelOpen = false;
  protected listOfMerchants: any[] = [];
  protected searchTerm = '';
  protected windowSize: 'mobile' | 'tablet' | 'desktop' | 'laptop' = 'desktop';
  private initialLoad = true;
  private modalInstance: NgbModalRef = {} as NgbModalRef;
  protected topBrands:any[] = [];
  protected topCategories:any[] = [];
  protected catsLoading = false;
  protected brandsLoading = false;
  private imgMap:any;
  protected isSearchLoading = false;
  @ViewChild('content', { static: false }) private modalContent: ElementRef|any;
  @Input() imgSize:'small'|'medium' = 'small';
  @Input() label = '';
  // @Output()
  constructor(
    private modalService: NgbModal,
    private _apiService: ApiService,
    private router: Router,
    private authService: AuthenticationService
  ) {
    this.imgMap = appConstants.imgCategoryMap;
    this.onResize();
  }

  public openSearchPanel(isOpen: boolean,template:any): void {
    if (this.windowSize === 'mobile' || this.windowSize === 'tablet') {
    } else {
      // console.log(this.modalInstance,'ModalInstance >>>>>>>')
      if (this.modalInstance && this.modalInstance.close) {
        this.modalInstance.close();
      }
      this.modalInstance = this.modalService.open(template,{modalDialogClass:'search-modal'});
    }
    this.isPanelOpen = isOpen;
    this.listOfMerchants = [];
    this.searchTerm = '';
    if(this.isPanelOpen){
      this.fetchBrandsAndCategories();
    }
  }

  fetchBrandsAndCategories(){
    // this._apiService.getMerchants();
    this.topCategories = [];
    this.topBrands = [];
    const replaceImage = (arr:any[]) =>{
      if(arr.length){
        arr.forEach((elem)=>{
          if(elem && elem.attributes.code && this.imgMap[elem.attributes.code]
            && this.imgMap[elem.attributes.code].logo_url){
            elem.attributes.logo_url = this.imgMap[elem.attributes.code].logo_url;
            // elem.base64 = true;
          }
        })
      }
    }
    this.catsLoading = true;
    this.brandsLoading = true;
    this._apiService.getCategoriesByProperty({context:'featured',per_page:6}).subscribe((resp:any)=>{
      console.log(resp,'fetchBrandsAndCategories');
      if(resp && resp.data){
        this.topCategories = resp.data;
        replaceImage(this.topCategories);
        this.topCategories = this.topCategories.slice(0,5);
      }
      this.catsLoading = false;
    });

    this._apiService.getMerchants({context:'featured',per_page:6}).subscribe((resp:any)=>{
      console.log(resp,'fetchBrandsAndCategories')
      if(resp && resp.data){
        this.topBrands = resp.data;
        this.topBrands = this.topBrands.slice(0,4);
      }
      this.brandsLoading = false;
    });
  }

  brandSearchEventHandler(eve: any): void {
    console.log(eve, 'SearchWidgetComponent brandSearchEventHandler');
    this.searchTerm = eve;
    if (this.searchTerm === '') {
      this.listOfMerchants = [];
    } else {
      if(this.searchTerm.length <3){
        this.listOfMerchants = [];
        return;
      }
      this.isSearchLoading = true;
      const labelAssigner: any = {
        'MembershipRedemptionOption': 'memberships',
        'GiftCardRedemptionOption': 'giftcards',
        'OfferRedemptionOption': 'offers'
      }
      const processCampaignData = (resp: any) => {
        if (resp && Object.keys(resp).length) {
          Object.keys(resp).forEach((key: string) => {
            if (resp[key].redemptions_info) {
              let keysArr = ['MembershipRedemptionOption', 'OfferRedemptionOption',
                'GiftCardRedemptionOption'];
              keysArr.forEach((contentKey: any) => {
                if (resp[key].redemptions_info[contentKey] &&
                  resp[key].redemptions_info[contentKey].length) {
                  this.listOfMerchants.push(
                    ...resp[key].redemptions_info[contentKey].map((obj: any) => ({
                      id: obj['redeemable_option_id'],
                      name: obj['name'],
                      searchType: key,
                      campaignType: labelAssigner[contentKey],
                      c_id: resp[key].campaign_id,
                    }))
                  );
                }
              });
   /*              this.listOfMerchants.push(
                 ... resp[key].redemptions_info.OfferRedemptionOption.map((obj: any) => ({
                    id: obj['id'],
                    name: obj['name'],
                    searchType: key,
                  }))
                ); */
              }
          });
        }
        // MembershipRedemptionOption
      }
      let apiObj:any = {
        generic : this._apiService.searchMerchants({ name: eve })
      }
      if(this.authService.isUserAuthenticated){
        apiObj['campaign'] = this._apiService.getCampaignOffers({merchant_name:eve});
      }
      this.listOfMerchants = [];
      // this.isLoading = true;
      // forkJoin([this._apiService.getRedemptions({ offer: true }), this._apiService.getGiftRedemptions(), this._apiService.getRewardBookings(), this._apiService.getRedemptions({ membership: true, special: 'true' }), this._apiService.getCards()]).subscribe((response: any) => {
      forkJoin(apiObj).subscribe((resp:any)=>{
        this.listOfMerchants = [];
        if(resp){
          if(resp['generic']){
            console.log(resp['generic'],'SearchWidgetComponent brandSearchEventHandler gen');
            if (resp['generic'] && resp['generic'].data) {
              const pushMerchants = (key: string, label: string): void => {
                this.listOfMerchants.push(
                  ...resp['generic'].data[key].map((obj: any) => ({
                    id: obj[0],
                    name: obj[1],
                    searchType: label,
                  }))
                );
              };
              pushMerchants('merchants', 'All Offers');
              pushMerchants('nearby_merchants', 'Offers Near Me');
              pushMerchants('international_merchants', 'International');
              console.log(this.listOfMerchants);

              // this.listOfMerchants = this.listOfMerchants.slice(0, 7);
              console.log(this.listOfMerchants);
            } else {
              this.listOfMerchants = [];
            }
          }
          if(resp['campaign']){
            console.log(resp['campaign'],'SearchWidgetComponent brandSearchEventHandler cam');
            processCampaignData(resp['campaign']);
          }
        }
        this.isSearchLoading = false;
      },(err:any)=>{
        this.isSearchLoading = false;
      });
    }
  }
  navigateToOfferDetails(item: {
    id: string;
    name: string;
    searchType: string;
    [x:string]:any;
  }) {
    let searchTerm = this.searchTerm
    this.preclosingActions();
    if(item['c_id']){
      this.router.navigate(['contextual', item['campaignType'] + '-details', item.id], { queryParams: { c_id: item['c_id'], search: searchTerm } })
    } else {
      const mapper:any = {
        "All Offers":'generic',
         'Offers Near Me':'nearme',
        'International':'international'
      }
      this.router.navigate(['offers','offer-details', item.id, (item.searchType && mapper[item.searchType]) ? mapper[item.searchType] : 'generic', item.name.split(' ').join('-').split(',').join('').split('(').join('').split(')').join('').toLowerCase()], {
        queryParams: {  categoryType: (item.searchType && mapper[item.searchType]) ? mapper[item.searchType] : 'generic', search: searchTerm },
      });
    }
  }
  selectTopItem(type:'cat'|'brand',item:any){
    console.log(item,'selectTopItem >>>>>>>>>>>>>>>>');
    if(type === 'cat'){
      this.preclosingActions();
      if (this.windowSize === 'mobile' || this.windowSize === 'tablet'){
        this.router.navigate(['offers-list'], {
          queryParams: {
            category_code: item.attributes?.code,
            categoryType: 'generic',
          },
        });
      } else {
        this.router.navigate(['./'], {
          queryParams: {
            category_code: item.attributes?.code
          },
        });
      }
    } else {
      this.navigateToOfferDetails(item);
    }
  }
  preclosingActions(){
    this.isPanelOpen = false;
    if(this.modalInstance && this.modalInstance.close){
      this.modalInstance.close();
    }
    this.listOfMerchants = [];
    this.searchTerm = '';
  }
  closePanel(){
    if(this.modalInstance && this.modalInstance.close){
      this.modalInstance.close();
    }
    this.searchTerm = '';
    this.listOfMerchants = [];
    this.isPanelOpen = false;
  }
  @HostListener('window:resize', ['$event'])
  protected onResize() {
    let prevWindow = this.windowSize;
    if (window.innerWidth >= 1200) {
      this.windowSize = 'desktop';
    } else if (window.innerWidth >= 992) {
      this.windowSize = 'laptop';
    } else if (window.innerWidth >= 768) {
      this.windowSize = 'tablet';
    } else {
      this.windowSize = 'mobile';
    }
    // console.log(this.windowSize, 'WindowSizeService >>>> onResize', prevWindow);
    if (this.initialLoad || prevWindow !== this.windowSize) {
      // this.openSearchPanel(true);
      this.initialLoad = false;
    }
  }
}
